export default class CartHelper {
  static hasValidAddressInfo = (addressInfo) => {
    const {
      "first_name": firstName,
      "last_name": lastName,
      "street_address_1": streetAddressOne
    } = addressInfo;
    const {zip, city, state} = addressInfo;

    if (
      firstName &&
      lastName &&
      streetAddressOne &&
      city &&
      state &&
      zip
    ) {
      return true;
    }
    return false;
  }

  static hasBillingInfo = (billingInfo) => {
    const {
      lastFour,
      paymentMethod
    } = billingInfo;

    if (paymentMethod === "Paypal") {
      return true;
    }

    if (!paymentMethod || !lastFour) return false;
    return true;
  };

  static addUnavailableClass = (id) => {
    const element = document.getElementById(id);

    if (element) {
      element.classList.add("unavailable-item");
      const listener = element.addEventListener("click", () => {
        element.classList.remove("unavailable-item");
        element.removeEventListener("click", listener);
      });
    }
  };

  static handlePurchaseError = (response, setErrorText) => {
    const unavailableClearancePds = response.clearance_unavailable_pds;
    const unavailableRetailPds = response.retail_unavailable_pds;

    if (unavailableClearancePds?.length > 0) {
      unavailableClearancePds.forEach((pd) => {
        this.addUnavailableClass(`${pd.id}-clearance`);
      });
    }

    if (unavailableRetailPds?.length > 0) {
      unavailableRetailPds.forEach((pd) => {
        this.addUnavailableClass(`${pd.id}-retail`);
      });
    }
    setErrorText(response.error);
  };

  static toCamelCase = (obj) => {
    const camelCaseObject = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const camelCaseKey = key.replace(/_([a-z])/g, word => word[1].toUpperCase());
        camelCaseObject[camelCaseKey] = obj[key];
      }
    }

    return camelCaseObject;
  };
}

